export async function fetchAll(resourceName, setStateFunction, sort) {
	try {
		var res;
		if (sort) {
			// Have to use var for some reason inside try/catch
			res = await fetch(
				`${process.env.REACT_APP_API_URL}/${resourceName}?sort=${sort}`,
				{ credentials: "include" }
			);
		} else {
			// Have to use var for some reason inside try/catch
			res = await fetch(`${process.env.REACT_APP_API_URL}/${resourceName}`, {
				credentials: "include",
			});
		}
		const allResources = await res.json();
		if (allResources.success) {
			setStateFunction(allResources.data);
		} else {
			console.log(allResources.error);
		}
	} catch (e) {
		console.log(e);
	}
}

export async function fetchOne(resourceName, id, setStateFunction) {
	try {
		const res = await fetch(
			`${process.env.REACT_APP_API_URL}/${resourceName}/${id}`,
			{
				credentials: "include",
			}
		);
		const resource = await res.json();
		if (resource.success) {
			setStateFunction(resource.data);
		} else {
			console.log(resource.error);
		}
	} catch (e) {
		console.log(e);
	}
}
